import { render, staticRenderFns } from "./_ContactBanner.vue?vue&type=template&id=24d8ec76&"
import script from "./_ContactBanner.vue?vue&type=script&lang=js&"
export * from "./_ContactBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports